import { TenantData } from '../services/api';

export function applyBackendTheme(tenantData: TenantData | null) {
  if (!tenantData?.theme) {
    return;
  }

  const { theme } = tenantData;
  const root = document.documentElement;

  // Apply light theme colors
  if (theme.lightBackground) root.style.setProperty('--background', theme.lightBackground);
  if (theme.lightForeground) root.style.setProperty('--foreground', theme.lightForeground);
  if (theme.lightPrimary) root.style.setProperty('--primary', theme.lightPrimary);
  if (theme.lightPrimaryForeground) root.style.setProperty('--primary-foreground', theme.lightPrimaryForeground);
  if (theme.lightSecondary) root.style.setProperty('--secondary', theme.lightSecondary);
  if (theme.lightSecondaryForeground) root.style.setProperty('--secondary-foreground', theme.lightSecondaryForeground);
  if (theme.lightMuted) root.style.setProperty('--muted', theme.lightMuted);
  if (theme.lightMutedForeground) root.style.setProperty('--muted-foreground', theme.lightMutedForeground);
  if (theme.lightAccent) root.style.setProperty('--accent', theme.lightAccent);
  if (theme.lightAccentForeground) root.style.setProperty('--accent-foreground', theme.lightAccentForeground);
  if (theme.lightDestructive) root.style.setProperty('--destructive', theme.lightDestructive);
  if (theme.lightDestructiveForeground) root.style.setProperty('--destructive-foreground', theme.lightDestructiveForeground);
  if (theme.lightBorder) root.style.setProperty('--border', theme.lightBorder);
  if (theme.lightInput) root.style.setProperty('--input', theme.lightInput);
  if (theme.lightRing) root.style.setProperty('--ring', theme.lightRing);
  if (theme.lightRadius) root.style.setProperty('--radius', theme.lightRadius);
  if (theme.lightChart1) root.style.setProperty('--chart-1', theme.lightChart1);
  if (theme.lightChart2) root.style.setProperty('--chart-2', theme.lightChart2);
  if (theme.lightChart3) root.style.setProperty('--chart-3', theme.lightChart3);
  if (theme.lightChart4) root.style.setProperty('--chart-4', theme.lightChart4);
  if (theme.lightChart5) root.style.setProperty('--chart-5', theme.lightChart5);

  // Apply dark theme colors
  if (theme.darkBackground) root.style.setProperty('--dark-background', theme.darkBackground);
  if (theme.darkForeground) root.style.setProperty('--dark-foreground', theme.darkForeground);
  if (theme.darkPrimary) root.style.setProperty('--dark-primary', theme.darkPrimary);
  if (theme.darkPrimaryForeground) root.style.setProperty('--dark-primary-foreground', theme.darkPrimaryForeground);
  if (theme.darkSecondary) root.style.setProperty('--dark-secondary', theme.darkSecondary);
  if (theme.darkSecondaryForeground) root.style.setProperty('--dark-secondary-foreground', theme.darkSecondaryForeground);
  if (theme.darkMuted) root.style.setProperty('--dark-muted', theme.darkMuted);
  if (theme.darkMutedForeground) root.style.setProperty('--dark-muted-foreground', theme.darkMutedForeground);
  if (theme.darkAccent) root.style.setProperty('--dark-accent', theme.darkAccent);
  if (theme.darkAccentForeground) root.style.setProperty('--dark-accent-foreground', theme.darkAccentForeground);
  if (theme.darkDestructive) root.style.setProperty('--dark-destructive', theme.darkDestructive);
  if (theme.darkDestructiveForeground) root.style.setProperty('--dark-destructive-foreground', theme.darkDestructiveForeground);
  if (theme.darkBorder) root.style.setProperty('--dark-border', theme.darkBorder);
  if (theme.darkInput) root.style.setProperty('--dark-input', theme.darkInput);
  if (theme.darkRing) root.style.setProperty('--dark-ring', theme.darkRing);
  if (theme.darkRadius) root.style.setProperty('--dark-radius', theme.darkRadius);
  if (theme.darkChart1) root.style.setProperty('--dark-chart-1', theme.darkChart1);
  if (theme.darkChart2) root.style.setProperty('--dark-chart-2', theme.darkChart2);
  if (theme.darkChart3) root.style.setProperty('--dark-chart-3', theme.darkChart3);
  if (theme.darkChart4) root.style.setProperty('--dark-chart-4', theme.darkChart4);
  if (theme.darkChart5) root.style.setProperty('--dark-chart-5', theme.darkChart5);
}

export function applyBackendBranding(tenantData: TenantData | null) {
  if (!tenantData?.config) {
    return;
  }

  const { config } = tenantData;

  // Update page title
  if (config.pageTitle) {
    document.title = config.pageTitle;
  }

  // Update favicon
  if (config.customFavicon) {
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingFavicons.forEach(link => link.remove());
    
    const faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/png';
    faviconLink.href = config.customFavicon;
    document.head.appendChild(faviconLink);
  }
}

